import { render, staticRenderFns } from "./InvitationLink.vue?vue&type=template&id=586d61cb&scoped=true"
import script from "./InvitationLink.vue?vue&type=script&lang=js"
export * from "./InvitationLink.vue?vue&type=script&lang=js"
import style0 from "./InvitationLink.vue?vue&type=style&index=0&id=586d61cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586d61cb",
  null
  
)

export default component.exports